var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-nav-main-right"},[_c('navigation-main-right-list'),_c('navigation-main-right-mobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }